import { TBColumn } from "../../interfaces/TableBits.interfaces";
const columns: TBColumn[] = [
  {
    id: "bussinesName",
    label: "Nombre",
    align: "left",
    width: 250,
  },
  {
    id: "campus",
    label: "Sede",
    align: "left",
    width: 100,
  },
  {
    id: "project",
    label: "Proyecto/Área",
    align: "left",
    width: 130,
  },
  {
    id: "client",
    label: "Sub Proyecto/Sub Área",
    align: "left",
    width: 250,
  },
  {
    id: "dateOfAdmission",
    label: "Fecha de ingreso",
    align: "left",
    width: 110,
  },
  {
    id: "Puesto",
    label: "Puesto",
    align: "left",
    width: 250,
  },
  {
    id: "grossSalary",
    label: "Sueldo",
    align: "left",
    width: 100,
  },
];

export default columns;
